import type {
	CreateOrganizationApiClientResponse,
	DeleteOrganizationApiClientRequest,
	DeleteOrganizationApiClientResponse,
	GetOrganizationApiClientsResponse,
} from "@somewear/api/src/proto/api/organization_pb";
import { createActionSet } from "@somewear/model";

import { CreateApiKeyForm } from "./apiKeys.types";

export const apiKeysActions = {
	getOrganizationApiKeys: createActionSet<void, GetOrganizationApiClientsResponse.AsObject>(
		"organization/apikeys/get",
	),
	createOrganizationApiKey: createActionSet<
		CreateApiKeyForm,
		CreateOrganizationApiClientResponse.AsObject
	>("organization/apikeys/create"),
	deleteOrganizationApiKey: createActionSet<
		DeleteOrganizationApiClientRequest.AsObject,
		DeleteOrganizationApiClientResponse.AsObject
	>("organization/apikeys/delete"),
};
